import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import isBefore from 'date-fns/isBefore'
import endOfToday from 'date-fns/endOfToday'
import { ScheduleCollectiveCalendarCell } from 'components/Calendar'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getClosedDates, getSpecialHolidays } from 'reducks/calendar/selectors'
import { dateToString } from 'lib/helper'
import { DaysOfWeek, DayOfWeekType } from 'lib/daysOfWeek'
import addDays from 'date-fns/addDays'
import { getStoreCalendars } from 'reducks/storeCalendar/selectors'
const daysOfWeek = new DaysOfWeek()

type Props = {
  activeDates: Date[]
  businessDays: DayOfWeekType[]
  currentMonth: Date
  row: Date[]
  selectDate: (date: Date) => void
}

const ScheduleCollectiveCalendarRow: FC<Props> = (props) => {
  const { activeDates, businessDays, currentMonth, row, selectDate } = props

  const specialHolidays = useSelector((state: State) => getSpecialHolidays(state))
  const closedDates = useSelector((state: State) => getClosedDates(state))
  const storeCalendars = useSelector((state: State) => getStoreCalendars(state))

  return (
    <tr className={styles.table__row}>
      {row.map((date) => {
        const isActive = activeDates.some((activeDate) => isSameDay(activeDate, date))
        const isClosed =
          closedDates.some((closeDate) => isSameDay(closeDate, date)) ||
          (!businessDays.includes(daysOfWeek.getDayOfWeek(date, specialHolidays)) &&
            !storeCalendars.some((calendar) => calendar.status === 'open' && calendar.date === dateToString(date)))
        const isSpecialHoliday = specialHolidays.some((specialHoliday) => specialHoliday.date === dateToString(date))
        return (
          <ScheduleCollectiveCalendarCell
            currentMonth={currentMonth}
            key={getDate(date)}
            date={date}
            isActive={isActive}
            isBefore={isBefore(date, addDays(endOfToday(), -1))}
            isClosed={isClosed}
            isSpecialHoliday={isSpecialHoliday}
            selectDate={selectDate}
          />
        )
      })}
    </tr>
  )
}

export default ScheduleCollectiveCalendarRow
